import { render } from "./MainDashboard.vue?vue&type=template&id=7efae67d&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=js"
export * from "./MainDashboard.vue?vue&type=script&lang=js"

import "./MainDashboard.vue?vue&type=style&index=0&id=7efae67d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efae67d"]])

export default __exports__